import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["promoPicList"];
import "core-js/modules/es.error.cause.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6b2c3994"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("招募公告");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看公告");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑公告");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增公告");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("选择品种");

const _hoisted_7 = {
  class: "tag-wrap"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("选择发起人");

const _hoisted_9 = {
  class: "tag-wrap"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("药企");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("代理商");

const _hoisted_12 = {
  class: "contact-row"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "8px",
    "color": "#909399"
  }
}, "万", -1));

const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_15 = ["src"];
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import { uploadFile } from '@/request/api';
import { getRecruitNoticeDetail, saveRecruitNotice, getRecruitAreaTree, getAttractConfig } from '@/request';
import AddVarietyModal from '@/components/AddVarietyModal.vue';
import SelectInitiatorModal from '@/views/RecruitHire/component/SelectInitiatorModal.vue';
export default {
  name: 'SaveRecruitNotice',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const treeRef = ref();
    const areaData = ref([]);
    const areaTreeKey = ref(0);
    const areaCheckedKeys = ref([]);
    const channelOptions = ref([]);
    const showProdModal = ref(false);
    const showInitiatorModal = ref(false);
    const showImgModal = ref(false);
    const showImgUrl = ref('');
    const uploadOption = {
      name: 'file',
      action: uploadFile.url
    };
    const isSee = computed(() => route.query.isSee === '1' || route.query.isSee === true);
    const isEdit = computed(() => !!route.query.id && !isSee.value);
    const form = ref({
      recruitId: null,
      title: '',
      recruiterName: '',
      recruiterIdentityType: null,
      recruiterAdvantage: '',
      recruiterIntro: '',
      positionName: '',
      annualIncome: 10,
      contactName: '',
      contactPhone: '',
      prodList: [],
      sponsorList: [],
      areaList: [],
      channelList: [],
      recruitCount: 10,
      maxAppliedCount: 10,
      publishDate: '',
      deadline: '',
      requirement: '',
      treatmentDesc: '',
      remark: '',
      promoPicList: []
    });
    const defaultSelectedInitiators = computed(() => form.value.sponsorList.map(item => ({
      supAccountId: item.id,
      linkMan: item.text,
      loginName: item.loginName || '',
      linkPhone: item.linkPhone || '',
      supplierName: item.supplierName || ''
    })));
    const channelIds = computed({
      get() {
        return form.value.channelList.map(c => c.id);
      },

      set(ids) {
        form.value.channelList = ids.map(id => {
          const found = channelOptions.value.find(c => c.id === id);
          return {
            id,
            text: found ? found.text : id
          };
        });
      }

    });
    const areaListRules = [{
      validator: (_rule, _value, callback) => {
        const list = collectAreaList();

        if (!list.length) {
          callback(new Error('请选择招募区域'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }];
    const sponsorListRules = [{
      validator: (_rule, _value, callback) => {
        if (!form.value.sponsorList.length) {
          callback(new Error('请选择发起人'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }];
    onMounted(() => {
      loadAreaTree();
      loadChannels();

      if (route.query.id) {
        loadDetail(route.query.id);
      }
    });

    function loadAreaTree() {
      getRecruitAreaTree().then(res => {
        areaData.value = res.data || [];
        areaTreeKey.value += 1;
      });
    }

    function loadChannels() {
      getAttractConfig().then(res => {
        channelOptions.value = res.data && res.data.userChannels || [];
      });
    }

    function loadDetail(recruitId) {
      getRecruitNoticeDetail({
        recruitId,
        __repeat: true
      }).then(res => {
        var _data$recruiterIdenti, _data$annualIncome;

        if (!res.success) return;
        const data = res.data || {};
        form.value = {
          recruitId: data.recruitId,
          title: data.title || '',
          recruiterName: data.recruiterName || '',
          recruiterIdentityType: (_data$recruiterIdenti = data.recruiterIdentityType) !== null && _data$recruiterIdenti !== void 0 ? _data$recruiterIdenti : null,
          recruiterAdvantage: data.recruiterAdvantage || '',
          recruiterIntro: data.recruiterIntro || '',
          positionName: data.positionName || '',
          annualIncome: (_data$annualIncome = data.annualIncome) !== null && _data$annualIncome !== void 0 ? _data$annualIncome : 10,
          contactName: data.contactName || '',
          contactPhone: data.contactPhone || '',
          prodList: data.prodList || [],
          sponsorList: data.sponsorList || [],
          areaList: data.areaList || [],
          channelList: data.channelList || [],
          recruitCount: data.recruitCount,
          maxAppliedCount: data.maxAppliedCount,
          publishDate: data.publishDate,
          deadline: data.deadline,
          requirement: data.requirement || '',
          treatmentDesc: data.treatmentDesc || '',
          remark: data.remark || '',
          promoPicList: (data.promoPicList || []).map((url, index) => ({
            name: `promo-${index}`,
            url
          }))
        };

        const applyCheckedKeys = () => {
          areaCheckedKeys.value = expandAreaCheckedKeys(data.areaList || [], areaData.value);
          areaTreeKey.value += 1;
          setTimeout(() => syncAreaFromTree(), 0);
        };

        if (areaData.value.length) {
          applyCheckedKeys();
        } else {
          getRecruitAreaTree().then(treeRes => {
            areaData.value = treeRes.data || [];
            applyCheckedKeys();
          });
        }
      });
    }

    function syncAreaFromTree() {
      var _formRef$value;

      form.value.areaList = collectAreaList();
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validateField('areaList');
    }

    function onProdSelected(rows) {
      const list = Array.isArray(rows) ? rows : [rows];
      list.forEach(row => {
        const id = String(row.varietyId);

        if (!form.value.prodList.find(p => String(p.id) === id)) {
          form.value.prodList.push({
            id,
            text: row.prodName
          });
        }
      });
    }

    function onInitiatorSelected(rows) {
      var _formRef$value2;

      form.value.sponsorList = (rows || []).map(row => ({
        id: String(row.supAccountId),
        text: row.linkMan || row.loginName || String(row.supAccountId),
        loginName: row.loginName,
        linkPhone: row.linkPhone,
        supplierName: row.supplierName
      }));
      (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validateField('sponsorList');
    }

    function collectAreaList() {
      if (!treeRef.value || !areaData.value.length) return [];
      const checkedKeys = new Set(treeRef.value.getCheckedKeys(false));
      const halfCheckedKeys = new Set(treeRef.value.getHalfCheckedKeys());
      const result = [];

      function visit(node, path) {
        var _node$children;

        const pathTexts = [...path, node.text];
        const hasChildren = ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0;

        if (hasChildren) {
          const fullySelected = checkedKeys.has(node.id) && !halfCheckedKeys.has(node.id);

          if (fullySelected) {
            result.push({
              id: node.id,
              text: pathTexts.join('.')
            });
            return true;
          }

          let any = false;
          node.children.forEach(child => {
            if (visit(child, pathTexts)) any = true;
          });
          return any;
        }

        if (checkedKeys.has(node.id)) {
          result.push({
            id: node.id,
            text: pathTexts.join('.')
          });
          return true;
        }

        return false;
      }

      areaData.value.forEach(node => visit(node, []));
      return result;
    }
    /** 回显：存了父级时，展开勾选其全部子节点 */


    function expandAreaCheckedKeys(areaList, tree) {
      if (!(areaList !== null && areaList !== void 0 && areaList.length)) return [];
      const keys = [];
      areaList.forEach(area => {
        var _node$children2;

        keys.push(area.id);
        const node = findNodeById(tree, area.id);

        if (node !== null && node !== void 0 && (_node$children2 = node.children) !== null && _node$children2 !== void 0 && _node$children2.length) {
          collectDescendantIds(node.children, keys);
        }
      });
      return [...new Set(keys)];
    }

    function collectDescendantIds(nodes, keys) {
      nodes.forEach(node => {
        var _node$children3;

        keys.push(node.id);

        if ((_node$children3 = node.children) !== null && _node$children3 !== void 0 && _node$children3.length) {
          collectDescendantIds(node.children, keys);
        }
      });
    }

    function findNodeById(tree, id) {
      for (const node of tree) {
        var _node$children4;

        if (node.id === id) return node;

        if ((_node$children4 = node.children) !== null && _node$children4 !== void 0 && _node$children4.length) {
          const found = findNodeById(node.children, id);
          if (found) return found;
        }
      }

      return null;
    }

    function promoPicBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小不可超过 1MB!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png 格式的文件');
        return false;
      }

      return true;
    }

    function uploadSuccess(data, key) {
      if (data.code === 1) {
        form.value[key] = form.value[key].map(file => {
          if (file.response) {
            file.url = file.response.data.picUrl;
          }

          return file;
        });
        return;
      }

      ElMessage.error(data.msg || '上传失败');
    }

    function previewImg(file) {
      showImgUrl.value = file.url;
      showImgModal.value = true;
    }

    function extractPromoPicUrl(item) {
      var _item$response, _item$response$data;

      if (!item) return '';
      if (typeof item === 'string') return item;
      return item.url || ((_item$response = item.response) === null || _item$response === void 0 ? void 0 : (_item$response$data = _item$response.data) === null || _item$response$data === void 0 ? void 0 : _item$response$data.picUrl) || '';
    }

    function buildPromoPicList(list) {
      return (list || []).map(extractPromoPicUrl).filter(Boolean);
    }

    function save() {
      syncAreaFromTree();
      formRef.value.validate(valid => {
        if (!valid) return;
        const areaList = form.value.areaList;

        if (!form.value.prodList.length) {
          ElMessage.warning('请关联品种');
          return;
        }

        if (!form.value.sponsorList.length) {
          ElMessage.warning('请选择发起人');
          return;
        }

        const _form$value = form.value,
              {
          promoPicList
        } = _form$value,
              formRest = _objectWithoutProperties(_form$value, _excluded);

        const payload = _objectSpread(_objectSpread({}, formRest), {}, {
          areaList,
          channelList: form.value.channelList,
          sponsorList: form.value.sponsorList,
          promoPicList: buildPromoPicList(promoPicList)
        });

        saveRecruitNotice(payload, {
          __repeat: true,
          __warn: true
        }).then(() => {
          ElMessage.success('保存成功');
          router.back();
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _unref(isSee) ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 0
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : _unref(isEdit) ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 1
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 2
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        disabled: _unref(isSee),
        "label-width": "140px",
        style: {
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "公告标题",
          prop: "title",
          rules: {
            required: true,
            message: '请输入公告标题'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.title = $event),
            maxlength: "200"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "关联品种",
          prop: "prodList",
          rules: {
            required: true,
            message: '请关联启用品种'
          }
        }, {
          default: _withCtx(() => [!_unref(isSee) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[2] || (_cache[2] = $event => showProdModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.prodList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_tag, {
              key: item.id,
              closable: !_unref(isSee),
              onClose: $event => form.value.prodList.splice(index, 1),
              class: "tag"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
              _: 2
            }, 1032, ["closable", "onClose"]);
          }), 128))]), _createVNode(_component_el_alert, {
            type: "info",
            closable: false,
            title: "从品种库选择启用品种，可不发招商；可多选"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "发起人",
          prop: "sponsorList",
          required: "",
          rules: sponsorListRules
        }, {
          default: _withCtx(() => [!_unref(isSee) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => showInitiatorModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.sponsorList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_tag, {
              key: item.id,
              closable: !_unref(isSee),
              onClose: $event => {
                var _formRef$value3;

                form.value.sponsorList.splice(index, 1);
                (_formRef$value3 = formRef.value) === null || _formRef$value3 === void 0 ? void 0 : _formRef$value3.validateField('sponsorList');
              },
              class: "tag"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
              _: 2
            }, 1032, ["closable", "onClose"]);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募方名称",
          prop: "recruiterName",
          rules: {
            required: true,
            message: '请填写招募方名称'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.recruiterName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.recruiterName = $event),
            placeholder: "填写企业/部门/团队名称",
            maxlength: "100",
            style: {
              "width": "420px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募方身份类型",
          prop: "recruiterIdentityType",
          rules: {
            required: true,
            message: '请选择招募方身份类型'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.value.recruiterIdentityType,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.recruiterIdentityType = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募方优势简述",
          prop: "recruiterAdvantage"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.recruiterAdvantage,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.recruiterAdvantage = $event),
            placeholder: "请输入招募方优势简述",
            maxlength: "20",
            "show-word-limit": "",
            style: {
              "width": "420px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募方简介",
          prop: "recruiterIntro"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.recruiterIntro,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.recruiterIntro = $event),
            type: "textarea",
            rows: 4,
            placeholder: "请输入招募方简介",
            maxlength: "200",
            "show-word-limit": "",
            style: {
              "width": "420px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募岗位名称",
          prop: "positionName",
          rules: {
            required: true,
            message: '请填写招募岗位名称'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.positionName,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.positionName = $event),
            placeholder: "请输入岗位名称",
            maxlength: "100",
            style: {
              "width": "420px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募联系方式:",
          required: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_form_item, {
            prop: "contactName",
            rules: {
              required: true,
              message: '联系人姓名不可为空'
            },
            class: "contact-form-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.contactName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.contactName = $event),
              placeholder: "姓名",
              maxlength: "20",
              style: {
                "width": "200px",
                "margin-right": "12px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "contactPhone",
            rules: {
              required: true,
              message: '联系方式不可为空'
            },
            class: "contact-form-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.contactPhone,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.contactPhone = $event),
              placeholder: "联系方式",
              maxlength: "20",
              style: {
                "width": "240px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招募区域",
          prop: "areaList",
          rules: areaListRules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            style: {
              "border": "1px solid #ccc",
              "border-radius": "8px",
              "padding": "10px",
              "width": "420px"
            },
            height: "300px"
          }, {
            default: _withCtx(() => [areaData.value.length ? (_openBlock(), _createBlock(_component_el_tree, {
              ref_key: "treeRef",
              ref: treeRef,
              key: areaTreeKey.value,
              data: areaData.value,
              "show-checkbox": "",
              "node-key": "id",
              "default-checked-keys": areaCheckedKeys.value,
              props: {
                label: 'text',
                children: 'children'
              },
              onCheck: syncAreaFromTree
            }, null, 8, ["data", "default-checked-keys"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "业务渠道",
          prop: "channelList",
          rules: {
            required: true,
            message: '请选择业务渠道'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(channelIds),
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(channelIds) ? channelIds.value = $event : null),
            multiple: "",
            placeholder: "",
            style: {
              "width": "420px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelOptions.value, ch => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: ch.id,
                label: ch.text,
                value: ch.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "年收入",
              prop: "annualIncome",
              rules: [{
                required: true,
                message: '请输入年收入'
              }, {
                type: 'number',
                min: 10,
                message: '年收入不能低于10万',
                trigger: 'change'
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.annualIncome,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.annualIncome = $event),
                min: 10,
                max: 999999,
                step: 10
              }, null, 8, ["modelValue"]), _hoisted_13]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "招募人数",
              prop: "recruitCount",
              rules: {
                required: true,
                message: '请输入招募人数'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.recruitCount,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.recruitCount = $event),
                min: 1,
                max: 99999
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "报名上限",
              prop: "maxAppliedCount",
              rules: {
                required: true,
                message: '请输入报名上限'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.value.maxAppliedCount,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.maxAppliedCount = $event),
                min: 1,
                max: 99999
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发布日期",
              prop: "publishDate",
              rules: {
                required: true,
                message: '请选择发布日期'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.publishDate,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.publishDate = $event),
                type: "date",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "截止日期",
              prop: "deadline",
              rules: {
                required: true,
                message: '请选择截止日期'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.deadline,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.deadline = $event),
                type: "date",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "人员要求"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.requirement,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.requirement = $event),
            type: "textarea",
            rows: 4,
            maxlength: "2000",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "待遇描述"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.treatmentDesc,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.treatmentDesc = $event),
            type: "textarea",
            rows: 4,
            maxlength: "2000",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.remark,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => form.value.remark = $event),
            maxlength: "500",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "宣传图"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: uploadOption.action,
            multiple: true,
            name: uploadOption.name,
            "before-upload": promoPicBeforeUpload,
            "on-preview": previewImg,
            "on-success": e => uploadSuccess(e, 'promoPicList'),
            "list-type": "picture-card",
            disabled: _unref(isSee),
            "file-list": form.value.promoPicList,
            "onUpdate:file-list": _cache[20] || (_cache[20] = $event => form.value.promoPicList = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "on-success", "disabled", "file-list"]), _createVNode(_component_el_alert, {
            type: "info",
            closable: false,
            title: "可上传多张，在小程序招募详情页底部平铺展示；建议 png/jpg/jpeg，单张不超过 1MB"
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "disabled"]), !_unref(isSee) ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(AddVarietyModal, {
        modelValue: showProdModal.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => showProdModal.value = $event),
        "check-mode": "checkbox",
        "selected-ids": form.value.prodList.map(p => Number(p.id)),
        onSuccess: onProdSelected
      }, null, 8, ["modelValue", "selected-ids"]), _createVNode(SelectInitiatorModal, {
        modelValue: showInitiatorModal.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => showInitiatorModal.value = $event),
        "default-selected": _unref(defaultSelectedInitiators),
        onSuccess: onInitiatorSelected
      }, null, 8, ["modelValue", "default-selected"]), _createVNode(_component_el_dialog, {
        modelValue: showImgModal.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => showImgModal.value = $event),
        width: "600px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: showImgUrl.value,
          style: {
            "width": "100%"
          },
          alt: "Preview Image"
        }, null, 8, _hoisted_15)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};